import { ws } from "../../../utils/common";

export const getAssociationNotificationsSendWS = async ({ id_association }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "notification/",
    { id_association },
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const getSingleNotificationsWS = async ({
  id_notification,
  id_association,
  question,
  id_event,
}) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "notification/" + id_notification,
    { id_association, id_event: id_event ?? 0, question: question ?? 0 },
    null,
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};
